import { environment } from "src/environments/environment";
import { Component, inject, Input, OnDestroy, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { MenuComponent } from "src/app/_metronic/kt/components";
import { TranslationService } from "src/app/i18n";
import { AuthService, UserType } from "src/app/pages/auth";
import { LocalStorageService } from "src/app/services/local-storage-service/local-storage.service";
import { CartService } from "src/app/services/api/carts.service";
import { AuthUtilitiesService } from "src/app/pages/auth/services/auth-utilities.service";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  standalone: false,
})
export class NavbarComponent implements OnInit, OnDestroy {
  @Input() appHeaderDefaulMenuDisplay: boolean;
  /** Set while a quiz is being sat — see HeaderComponent.focusMode. */
  @Input() hideCart = false;
  @Input() isRtl: boolean;

  itemClass: string = "ms-1 ms-lg-3";
  btnClass: string =
    "btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px";
  userAvatarClass: string = "symbol-35px symbol-md-40px";
  btnIconClass: string = "fs-2 fs-md-1";

  toggleCounter = 0;

  environment = environment;

  user$: Observable<UserType>;
  #auth = inject(AuthService);
  #localStorageService = inject(LocalStorageService);
  #cartService = inject(CartService);
  is_destroyed: boolean = false;

  currentUser = this.#auth.currentUser;
  useCart = this.#cartService.userCart;
  #loginService = inject(AuthUtilitiesService);

  /** Same dialog the auth guard opens — this app has no /login route. */
  openLogin(): void {
    this.#loginService.openLoginDialog();
  }

  constructor() {}
  ngOnDestroy(): void {
    MenuComponent.reinitialization();
    this.#localStorageService.setItem("navbar-destroy", "true");
  }

  ngAfterViewInit() {
    MenuComponent.reinitialization();
    setTimeout(() => {
      this.triggerClick();
    }, 200); //delay to click empty for first init component
  }
  triggerClick() {
    const nav_item = document.getElementById("navbar-menu-trigger");
    if (nav_item) {
      nav_item.click();
    }
  }

  ngOnInit(): void {
    this.user$ = this.#auth.currentUserSubject.asObservable();
    this.is_destroyed =
      this.#localStorageService.getItem("navbar-destroy") === "true";
    MenuComponent.reinitialization();
    this.#localStorageService.removeItem("navbar-destroy");
    this.#localStorageService.removeItem("user-menu");
    this.updateCart();
  }

  async updateCart() {
    if (this.currentUser()) {
      const res = await this.#cartService.getUserCart();
      this.useCart = this.#cartService.userCart;
    }
  }

  _setUserToggle(e: Event) {
    if (this.toggleCounter === 0) {
      const menu_element = document.getElementById(
        "user-dropdown"
      ) as HTMLElement;
      const menu = MenuComponent.getInstance(menu_element) as MenuComponent;
      //Delay click for MenuComponent call .click 2 times
      setTimeout(() => {
        menu.click(menu_element, e);
      }, 0);
      setTimeout(() => {
        //Delay click when user click other btn
        if (this.#localStorageService.getItem("user-menu") === "hide") {
          menu.click(menu_element, e);
        }
      }, 20);
      if (this.is_destroyed) {
        //Delay click when navbar destroy
        setTimeout(() => {
          menu.click(menu_element, e);
        }, 0);
      }
      this.toggleCounter += 1;
    }
  }
}
